export enum NavigationSourceQueryEnum {
  Profile = 'profile',
  Search = 'search',
  SearchContractNumber = 'searchContractNumber',
  AnchorSearch = 'anchorSearch',
  Verification = 'verification',
  BackToVerification = 'backToVerification',
  Dialer = 'dialer',
  Ecommerce = 'ecommerce',
  WrapCall = 'wrapCall',
  Quote = 'quote',
  DoNotMail = 'doNotMail',
  CustomerServiceVerification = 'customerServiceVerification',
  Vehicle = 'vehicle',
  Transfer = 'transfer',
}
